import { render } from "./orderList.vue?vue&type=template&id=135953ae&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"

import "./orderList.vue?vue&type=style&index=0&id=135953ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-135953ae"

export default script